import {
  useWatch,
  type Control,
  type UseFormClearErrors
} from 'react-hook-form'
import { useEffect } from 'react'
import type { PackagesFormStateType } from '../types'

type HotelFormSubmitValues = {
  clearErrors: UseFormClearErrors<PackagesFormStateType>
  control: Control<PackagesFormStateType>
  initialValues: PackagesFormStateType
}

export default function usePackagesFormSubmitValues({
  clearErrors,
  control,
  initialValues
}: HotelFormSubmitValues) {
  const watchTripType = useWatch({
    control,
    name: 'tripType',
    defaultValue: initialValues.tripType
  })
  const watchPartialStay = useWatch({
    control,
    name: 'partialStay',
    defaultValue: initialValues.partialStay
  })
  const watchStartLocation = useWatch({
    control,
    name: 'startLocation',
    defaultValue: initialValues.startLocation
  })
  const watchEndLocation = useWatch({
    control,
    name: 'endLocation',
    defaultValue: initialValues.endLocation
  })
  const watchStartDate = useWatch({
    control,
    name: 'startDate',
    defaultValue: initialValues.startDate
  })
  const watchEndDate = useWatch({
    control,
    name: 'endDate',
    defaultValue: initialValues.endDate
  })
  const watchTravelers = useWatch({
    control,
    name: 'travelers',
    defaultValue: initialValues.travelers
  })
  const watchHotelStartDate = useWatch({
    control,
    name: 'hotelStartDate',
    defaultValue: initialValues.hotelStartDate
  })
  const watchHotelEndDate = useWatch({
    control,
    name: 'hotelEndDate',
    defaultValue: initialValues.hotelEndDate
  })
  const watchPickupCarSomewhere = useWatch({
    control,
    name: 'pickupCarSomewhere',
    defaultValue: initialValues.pickupCarSomewhere
  })
  const watchRcLocation = useWatch({
    control,
    name: 'rcLocation',
    defaultValue: initialValues.rcLocation
  })
  const watchRcPickupDate = useWatch({
    control,
    name: 'rcPickupDate',
    defaultValue: initialValues.rcPickupDate
  })
  const watchRcDropoffDate = useWatch({
    control,
    name: 'rcDropoffDate',
    defaultValue: initialValues.rcDropoffDate
  })
  const watchRcPickupTime = useWatch({
    control,
    name: 'rcPickupTime',
    defaultValue: initialValues.rcPickupTime
  })
  const watchRcDropoffTime = useWatch({
    control,
    name: 'rcDropoffTime',
    defaultValue: initialValues.rcDropoffTime
  })

  // clear errors when location change
  useEffect(() => {
    clearErrors('startLocation')
  }, [clearErrors, watchStartLocation])
  useEffect(() => {
    clearErrors('endLocation')
  }, [clearErrors, watchEndLocation])
  useEffect(() => {
    clearErrors('rcLocation')
  }, [clearErrors, watchRcLocation])

  // clear errors when dates change
  useEffect(() => {
    clearErrors('startDate')
  }, [clearErrors, watchStartDate])
  useEffect(() => {
    clearErrors('endDate')
  }, [clearErrors, watchEndDate])
  useEffect(() => {
    clearErrors('hotelStartDate')
  }, [clearErrors, watchHotelStartDate])
  useEffect(() => {
    clearErrors('hotelEndDate')
  }, [clearErrors, watchHotelEndDate])
  useEffect(() => {
    clearErrors('rcPickupDate')
  }, [clearErrors, watchRcPickupDate])
  useEffect(() => {
    clearErrors('rcDropoffDate')
  }, [clearErrors, watchRcDropoffDate])

  return {
    watchTripType,
    watchPartialStay,
    watchStartLocation,
    watchEndLocation,
    watchStartDate,
    watchEndDate,
    watchTravelers,
    watchHotelStartDate,
    watchHotelEndDate,
    watchPickupCarSomewhere,
    watchRcLocation,
    watchRcPickupDate,
    watchRcDropoffDate,
    watchRcPickupTime,
    watchRcDropoffTime
  }
}
